import { useDispatchSessionStore } from './useDispatchSessionStore';
import { DispatchSessionPoller } from './DispatchSessionPoller';

// Headless. Renders one poller per pending dispatch session (registered from
// the bulk-move success handler, or rehydrated from sessionStorage on refresh).
// Replaces the old count-guessing useBulkAutomationCompletionWatcher.
export const DispatchSessionWatcher = () => {
  const sessions = useDispatchSessionStore((s) => s.sessions);
  return (
    <>
      {sessions.map((session) => (
        <DispatchSessionPoller key={session.sessionId} session={session} />
      ))}
    </>
  );
};
